module.exports = __webpack_public_path__ + "img/metaverse-banner-header.dcc7d493.png";